module.exports = __webpack_public_path__ + "img/sigladark.d6e66c12.svg";